import { render } from "./Research.vue?vue&type=template&id=719df166"
import script from "./Research.vue?vue&type=script&lang=ts"
export * from "./Research.vue?vue&type=script&lang=ts"

import "./Research.vue?vue&type=style&index=0&id=719df166&lang=scss"
script.render = render

export default script